/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Access Administration API
 * OpenAPI spec version: 1.0.0
 */
import type {
  AssignRolePermissionRequest,
  CreateRoleRequest,
  ListAccessAdministrationRolesParams,
  PaginatedRoleDto,
  RoleDto,
  RoleId,
} from "../model";

import {customFetch} from "../../../runtime/custom-fetch";

export const getCreateAccessAdministrationRoleUrl = () => {
  return `/api/v1/access-administration/roles`;
};

/**
 * @summary Create role
 */
export const createAccessAdministrationRole = async (
  createRoleRequest: CreateRoleRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<RoleId> => {
  return customFetch<RoleId>(getCreateAccessAdministrationRoleUrl(), {
    ...options,
    method: "POST",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(createRoleRequest),
  });
};

export const getListAccessAdministrationRolesUrl = (
  params: ListAccessAdministrationRolesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/access-administration/roles?${stringifiedParams}`
    : `/api/v1/access-administration/roles`;
};

/**
 * @summary List roles
 */
export const listAccessAdministrationRoles = async (
  params: ListAccessAdministrationRolesParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<PaginatedRoleDto> => {
  return customFetch<PaginatedRoleDto>(getListAccessAdministrationRolesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getAssignAccessAdministrationRolePermissionUrl = (roleId: string) => {
  return `/api/v1/access-administration/roles/${roleId}/permissions`;
};

/**
 * @summary Assign permission to role
 */
export const assignAccessAdministrationRolePermission = async (
  roleId: string,
  assignRolePermissionRequest: AssignRolePermissionRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getAssignAccessAdministrationRolePermissionUrl(roleId), {
    ...options,
    method: "POST",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(assignRolePermissionRequest),
  });
};

export const getRemoveAccessAdministrationRolePermissionUrl = (
  roleId: string,
  permissionKey: string,
) => {
  return `/api/v1/access-administration/roles/${roleId}/permissions/${permissionKey}`;
};

/**
 * @summary Remove permission from role
 */
export const removeAccessAdministrationRolePermission = async (
  roleId: string,
  permissionKey: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getRemoveAccessAdministrationRolePermissionUrl(roleId, permissionKey), {
    ...options,
    method: "DELETE",
  });
};

export const getGetAccessAdministrationRoleUrl = (roleId: string) => {
  return `/api/v1/access-administration/roles/${roleId}`;
};

/**
 * @summary Get role
 */
export const getAccessAdministrationRole = async (
  roleId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<RoleDto> => {
  return customFetch<RoleDto>(getGetAccessAdministrationRoleUrl(roleId), {
    ...options,
    method: "GET",
  });
};
